import { IntakesManager } from "@/pages/settings/IntakesManager";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui-kit/Card";

export function ClientIntakesCard() {
  return (
    <Card data-testid="intakes-card">
      <CardHeader>
        <CardTitle>Client intakes</CardTitle>
        <CardDescription>
          Submissions from the public welcome page (<code>/welcome</code>) that you text to referred clients. Review
          their contact details and ACSA acknowledgment, start a new client from one, or mark each handled.
        </CardDescription>
      </CardHeader>
      <CardContent><IntakesManager /></CardContent>
    </Card>
  );
}
